var _path, _mask, _ellipse, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53748 4.49599L28.3387 6.74049C29.7022 6.87472 30.7037 8.08145 30.5843 9.44636L30.2445 13.3295C30.1463 14.4521 29.3093 15.3701 28.2006 15.5714L9.4299 18.9795M1.49219 1.73418L3.51069 2.15365C4.47741 2.35454 5.23533 3.1056 5.44501 4.07045L9.72359 23.7586C9.97335 24.9079 10.9904 25.7277 12.1666 25.7277H30.3566",
    stroke: "#404040",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_217_5723",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.70052,
    cy: 30.4632,
    rx: 2.05208,
    ry: 2.05208
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.70052,
    cy: 30.4632,
    rx: 2.05208,
    ry: 2.05208,
    fill: "#404040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7526 30.4632H8.75259C8.75259 29.9397 9.17699 29.5153 9.70052 29.5153V32.5153V35.5153C12.4907 35.5153 14.7526 33.2534 14.7526 30.4632H11.7526ZM9.70052 32.5153V29.5153C10.224 29.5153 10.6484 29.9397 10.6484 30.4632H7.64844H4.64844C4.64844 33.2534 6.91033 35.5153 9.70052 35.5153V32.5153ZM7.64844 30.4632H10.6484C10.6484 30.9868 10.224 31.4112 9.70052 31.4112V28.4112V25.4112C6.91033 25.4112 4.64844 27.6731 4.64844 30.4632H7.64844ZM9.70052 28.4112V31.4112C9.17699 31.4112 8.75259 30.9868 8.75259 30.4632H11.7526H14.7526C14.7526 27.6731 12.4907 25.4112 9.70052 25.4112V28.4112Z",
    fill: "#404040",
    mask: "url(#path-2-inside-1_217_5723)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.8529,
    cy: 30.4632,
    r: 1.5,
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 1.10415
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b9ecd5206080ed2883342de7cfa5a57b.svg";
export { ForwardRef as ReactComponent };